import React from 'react'

import { t } from 'i18next'

import GoalCampaignCardPureComponent from './PureComponent'

const GoalCampaignCard: React.FC<GoalCampaignCardProps> = ({ ...args }) => {
  return (
    <GoalCampaignCardPureComponent
      {...args}
      recommendedForTitle={t(
        'rm:objectiveBased.card.common.recommendedFor.title'
      )}
      adcostObjectiveTitle={t(
        'rm:objectiveBased.card.common.acosObjective.title'
      )}
    />
  )
}

export default GoalCampaignCard
